import { call, put, takeLatest } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import * as ApiRoute from 'constants/apiRouting'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import { SITE_TYPE_SEAWATER } from 'constants/index'
import {
  FETCH_PROJECTED_SITES_MANAGER_LIST,
  FETCH_PROJECTED_SITES_MANAGER_FILTERS,
  SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER,
  SUCCESS_PROJECTED_SITES_MANAGER_LIST,
  FAILURE_PROJECTED_SITES_MANAGER_SINGLE_ITEM,
  SUCCESS_PROJECTED_SITES_MANAGER_FILTERS,
  SUCCESS_PROJECTED_SITES_MANAGER_ITEM_UPDATE,
  SAVE_LIST_FORM,
  SET_IS_SAVING_FORM,
  SUCCESS_PROJECTED_SITES_MANAGER_CLIENTS,
  FETCH_PROJECTED_SITES_MANAGER_CLIENTS,
  SUCCESS_PROJECTED_SITES_MANAGER_REGIONS,
  FETCH_PROJECTED_SITES_MANAGER_REGIONS,
  SUCCESS_PROJECTED_SITES_MANAGER_SITES,
  FETCH_PROJECTED_SITES_MANAGER_SITES,
  SUCCESS_PROJECTED_SITES_MANAGER_SPECIES,
  FETCH_PROJECTED_SITES_MANAGER_SPECIES,
  SUCCESS_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY,
  FETCH_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY,
  FETCH_PROJECTED_SITES_MANAGER_SINGLE_ITEM,
  SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM,
  FAILURE_PROJECTED_SITES_MANAGER_SITE,
  FETCH_PROJECTED_SITES_MANAGER_BASE_PRODUCTS,
  FETCH_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS,
  SUCCESS_PROJECTED_SITES_MANAGER_BASE_PRODUCTS,
  SUCCESS_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS,
  SAVE_SINGLE_ITEM_FORM,
  SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM_UPDATE,
  FETCH_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709,
  SUCCESS_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709,
  FETCH_PROJECTED_SITES_MANAGER_SNAPSHOTS,
  SUCCESS_PROJECTED_SITES_MANAGER_SNAPSHOTS,
  UPDATE_PROJECTED_SITES_MANAGER_SNAPSHOT,
  SET_PROJECTED_SITES_MANAGER_SNAPSHOTS_LOADER,
  FETCH_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS,
  SUCCESS_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS,
  SUCCESS_PROJECTED_SITES_MANAGER_DIET_GROUPS,
  FETCH_PROJECTED_SITES_MANAGER_DIET_GROUPS,
} from './reducer'
import { SHOW_NOTICE } from '../notice'

function* fetchProjectedSitesManagerList({ payload }) {
  try {
    const { siteType, snapshot } = payload

    yield put({
      type: SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER,
      payload: true,
    })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(
        snapshot !== 'main-table'
          ? ApiRoute.PROJECTED_SITES_MANAGER_TABLE_SNAPSHOT_DATA
          : ApiRoute.PROJECTED_SITES_MANAGER_TABLE_DATA,
        { siteType, snapshot },
      )}${UrlHelper.getPsfsQuery(payload)}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_PROJECTED_SITES_MANAGER_SINGLE_ITEM })
    }

    yield put({
      type: SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER,
      payload: false,
    })
  } catch (error) {
    console.error('PROJECTED SITES MANAGER SITE LIST FETCH FAILED:', error)
  }
}

function* fetchProjectedSitesManagerSingleItem({ payload, promise }) {
  try {
    const { siteType, snapshot, siteId, specieId, year } = payload
    const isSeawater = siteType === SITE_TYPE_SEAWATER
    const itemType = isSeawater ? 'site' : 'client'

    yield put({
      type: SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER,
      payload: true,
    })

    const partUrl = `${UrlHelper.create(
      snapshot !== 'main-table'
        ? ApiRoute.PROJECTED_SITES_MANAGER_SITE_TABLE_SNAPSHOT_DATA
        : ApiRoute.PROJECTED_SITES_MANAGER_SITE_TABLE_DATA,
      { siteType, snapshot },
    )}${UrlHelper.getPsfsQuery(payload)}&${itemType}=${siteId}${
      isSeawater ? `&specie=${specieId}${year ? `&year=${year}` : ''}` : ''
    }`

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl,
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_PROJECTED_SITES_MANAGER_SITE })
    }

    yield put({
      type: SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER,
      payload: false,
    })

    if (promise && promise.resolve) {
      return yield call(promise.resolve)
    }
  } catch (error) {
    console.error('PROJECTED SITES MANAGER SINGLE ITEM FETCH FAILED:', error)
  }
}

function* saveListForm({
  payload: { data, id, sucessMessage, isEditMode = false, siteType, snapshot },
  promise,
}) {
  try {
    const method = isEditMode ? 'PUT' : 'POST'
    // eslint-disable-next-line no-nested-ternary
    const partUrl = isEditMode
      ? snapshot !== 'main-table'
        ? UrlHelper.create(ApiRoute.PROJECTED_SITES_MANAGER_SNAPSHOT_ITEM, {
            id,
            siteType,
            snapshot,
          })
        : UrlHelper.create(ApiRoute.PROJECTED_SITES_MANAGER_ITEM, {
            id,
            siteType,
          })
      : snapshot !== 'main-table'
      ? UrlHelper.create(ApiRoute.PROJECTED_SITES_MANAGER_WITH_SNAPSHOT, {
          siteType,
          snapshot,
        })
      : UrlHelper.create(ApiRoute.PROJECTED_SITES_MANAGER_WITH_SITE_TYPE, {
          siteType,
        })

    yield put({ type: SET_IS_SAVING_FORM, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl,
      method,
      data,
    })

    if (!response.hasOwnProperty('error')) {
      if (sucessMessage) {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createSuccessObj(sucessMessage),
        })
      }
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_ITEM_UPDATE,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch item failed',
          response.error,
        ),
      })
    }

    yield put({ type: SET_IS_SAVING_FORM, payload: false })

    if (promise && promise.resolve) {
      yield call(promise.resolve)
    }
  } catch (error) {
    console.error('PROJECTED SITES MANAGER SAVE LIST FORM FAILED:', error)
  }
}

function* saveSingleItemForm({
  payload: { data, id, sucessMessage, siteType, snapshot },
  promise,
}) {
  try {
    yield put({ type: SET_IS_SAVING_FORM, payload: true })
    // eslint-disable-next-line no-nested-ternary
    const partUrl =
      // eslint-disable-next-line no-nested-ternary
      siteType === SITE_TYPE_SEAWATER
        ? snapshot !== 'main-table'
          ? UrlHelper.create(
              ApiRoute.PROJECTED_SITES_MANAGER_SNAPSHOT_ITEM_ROW,
              { id, siteType, snapshot },
            )
          : UrlHelper.create(ApiRoute.PROJECTED_SITES_MANAGER_ITEM_ROW, {
              id,
              siteType,
            })
        : snapshot !== 'main-table'
        ? UrlHelper.create(
            ApiRoute.PROJECTED_SITES_MANAGER_SNAPSHOT_PROJECTIONS,
            { siteType, snapshot },
          )
        : UrlHelper.create(ApiRoute.PROJECTED_SITES_MANAGER_PROJECTIONS, {
            siteType,
          })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl,
      method: 'PUT',
      data,
    })

    if (!response.hasOwnProperty('errors')) {
      if (sucessMessage) {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createSuccessObj(sucessMessage),
        })
      }
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM_UPDATE,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch item row failed',
          response.error,
        ),
      })

      yield put({ type: SET_IS_SAVING_FORM, payload: false })

      return yield call(promise.resolve(response.errors))
    }

    yield put({ type: SET_IS_SAVING_FORM, payload: false })

    if (promise && promise.resolve) {
      yield call(promise.resolve)
    }
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER ITEM ROW FAILED:', error)
  }
}

function* fetchProjectedSitesManagerFilters({ payload: siteType, promise }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.PROJECTED_SITES_MANAGER_SEAWATER_FILTERS,
        { siteType },
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_FILTERS,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch filters failed',
          response.error,
        ),
      })
    }

    if (promise && promise.resolve) {
      yield call(promise.resolve)
    }
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER FILTERS FAILED:', error)
  }
}

function* fetchProjectedSitesManagerClients({ payload: siteType }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.PROJECTED_SITES_MANAGER_CLIENTS, {
        siteType,
      }),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_CLIENTS,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch clients failed',
          response.error,
        ),
      })
    }
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER CLIENTS FAILED:', error)
  }
}

function* fetchProjectedSitesManagerSites({ payload }) {
  try {
    yield put({ type: SET_IS_SAVING_FORM, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.PROJECTED_SITES_MANAGER_SITES,
        payload,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_SITES,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch sites failed',
          response.error,
        ),
      })
    }

    yield put({ type: SET_IS_SAVING_FORM, payload: false })
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER SITES FAILED:', error)
  }
}

function* fetchProjectedSitesManagerBaseProducts({ payload }) {
  try {
    yield put({ type: SET_IS_SAVING_FORM, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.PROJECTED_SITES_MANAGER_BASE_PRODUCTS,
        payload,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_BASE_PRODUCTS,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch base products failed',
          response.error,
        ),
      })
    }

    yield put({ type: SET_IS_SAVING_FORM, payload: false })
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER BASE PRODUCTS FAILED:', error)
  }
}

function* fetchProjectedSitesManagerDietGroups({ payload }) {
  try {
    yield put({ type: SET_IS_SAVING_FORM, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.PROJECTED_SITES_MANAGER_DIET_GROUPS,
        payload,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_DIET_GROUPS,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch base products failed',
          response.error,
        ),
      })
    }

    yield put({ type: SET_IS_SAVING_FORM, payload: false })
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER BASE PRODUCTS FAILED:', error)
  }
}

function* fetchProjectedSitesManagerProjectedProducts({ payload }) {
  try {
    yield put({ type: SET_IS_SAVING_FORM, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(
        ApiRoute.PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS,
        payload,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch projected products failed',
          response.error,
        ),
      })
    }

    yield put({ type: SET_IS_SAVING_FORM, payload: false })
  } catch (error) {
    console.error(
      'FETCH PROJECTED SITES MANAGER PROJECTED PRODUCTS FAILED:',
      error,
    )
  }
}

function* fetchProjectedSitesManagerRegions() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.PROJECTED_SITES_MANAGER_REGIONS,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_REGIONS,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch regions failed',
          response.error,
        ),
      })
    }
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER REGIONS FAILED:', error)
  }
}

const LOOKUP_TABLE_709 = '709'

function* fetchProjectedSitesManagerLookupTable709() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRoute.PROJECTED_SITES_MANAGER_LOOKUP, {
        table: LOOKUP_TABLE_709,
      }),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch lookup table 709 failed',
          response.error,
        ),
      })
    }
  } catch (error) {
    console.error(
      'FETCH PROJECTED SITES MANAGER LOOKUP TABLE 709 FAILED:',
      error,
    )
  }
}

function* fetchProjectedSitesManagerSpecies() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.PROJECTED_SITES_MANAGER_SPECIES,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_SPECIES,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch species failed',
          response.error,
        ),
      })
    }
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER SPECIES FAILED:', error)
  }
}

function* fetchProjectedSitesManagerProductFamily() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.PROJECTED_SITES_MANAGER_PRODUCT_FAMILY,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch product family failed',
          response.error,
        ),
      })
    }
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER PRODUCT FAMILY FAILED:', error)
  }
}

function* fetchProjectedSitesManagerSnapshots({
  payload: { method = 'GET' } = {},
  promise,
}) {
  try {
    yield put({
      type: SET_PROJECTED_SITES_MANAGER_SNAPSHOTS_LOADER,
      payload: true,
    })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.PROJECTED_SITES_MANAGER_SNAPSHOTS,
      method,
    })

    if (!response.hasOwnProperty('error')) {
      if (method === 'GET') {
        yield put({
          type: SUCCESS_PROJECTED_SITES_MANAGER_SNAPSHOTS,
          payload: response,
        })
      }

      if (promise && promise.resolve) {
        yield call(promise.resolve)
      }
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch snapshots failed',
          response.error,
        ),
      })
    }

    yield put({
      type: SET_PROJECTED_SITES_MANAGER_SNAPSHOTS_LOADER,
      payload: false,
    })
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER SNAPSHOTS FAILED:', error)
  }
}

function* updateProjectedSitesManagerSnapshot({
  payload: { id, data, method = 'PATCH' },
  promise,
}) {
  try {
    yield put({
      type: SET_PROJECTED_SITES_MANAGER_SNAPSHOTS_LOADER,
      payload: true,
    })

    const isDuplicateAction = method === 'PUT'

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(
        ApiRoute.PROJECTED_SITES_MANAGER_UPDATE_SNAPSHOT,
        {
          id,
        },
      )}${isDuplicateAction ? '/duplicate' : ''}`,
      method,
      data,
    })

    if (promise && promise.resolve) {
      yield call(promise.resolve, response)
    }

    yield put({
      type: SET_PROJECTED_SITES_MANAGER_SNAPSHOTS_LOADER,
      payload: false,
    })
  } catch (error) {
    console.error('FETCH PROJECTED SITES MANAGER SNAPSHOTS FAILED:', error)
  }
}

function* fetchProjectedSitesManagerUsersAndGroups() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRoute.PROJECTED_SITES_MANAGER_USERS_AND_GROUPS,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS,
        payload: response,
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'fetch users and groups failed',
          response.error,
        ),
      })
    }
  } catch (error) {
    console.error(
      'FETCH PROJECTED SITES MANAGER USERS AND GROUPS FAILED:',
      error,
    )
  }
}

function* projectedSitesManagerSaga() {
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_LIST,
    fetchProjectedSitesManagerList,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_SINGLE_ITEM,
    fetchProjectedSitesManagerSingleItem,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_FILTERS,
    fetchProjectedSitesManagerFilters,
  )
  yield takeLatest(SAVE_LIST_FORM, saveListForm)
  yield takeLatest(SAVE_SINGLE_ITEM_FORM, saveSingleItemForm)
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_CLIENTS,
    fetchProjectedSitesManagerClients,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_SITES,
    fetchProjectedSitesManagerSites,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_BASE_PRODUCTS,
    fetchProjectedSitesManagerBaseProducts,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_DIET_GROUPS,
    fetchProjectedSitesManagerDietGroups,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS,
    fetchProjectedSitesManagerProjectedProducts,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_REGIONS,
    fetchProjectedSitesManagerRegions,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_SPECIES,
    fetchProjectedSitesManagerSpecies,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY,
    fetchProjectedSitesManagerProductFamily,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709,
    fetchProjectedSitesManagerLookupTable709,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_SNAPSHOTS,
    fetchProjectedSitesManagerSnapshots,
  )
  yield takeLatest(
    UPDATE_PROJECTED_SITES_MANAGER_SNAPSHOT,
    updateProjectedSitesManagerSnapshot,
  )
  yield takeLatest(
    FETCH_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS,
    fetchProjectedSitesManagerUsersAndGroups,
  )
}

export default projectedSitesManagerSaga
